(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1794],{

/***/ 1794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22974);
/* harmony import */ var _InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53027);
/* harmony import */ var _Long_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10356);
/* harmony import */ var _Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Long_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var content = {
    heading: "Looking for {talentType}?",
    description: "Access top performing {talentType} and other experts with a track record of helping top companies develop a world-class customer experience. Connect with a Hire Digital Director to find the talent you need.",
    viewMoreButtonLabel: "View More Profiles",
    images: [
        {
            url: "/img/Image_1.webp",
            width: "160px",
            height: "160px"
        },
        {
            url: "/img/Image_2.webp",
            width: "192px",
            height: "128px"
        },
        {
            url: "/img/Image_3.webp",
            width: "160px",
            height: "240px"
        },
        {
            url: "/img/Image_4.webp",
            width: "160px",
            height: "240px"
        },
        {
            url: "/img/Image_5.webp",
            width: "192px",
            height: "128px"
        }, 
    ]
};
var LongCTA = function(param) {
    var talentType = param.talentType, description = param.description, analyticsData = param.analyticsData;
    return(// Container
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().gridContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().gridItem),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().heading),
                        children: [
                            "No long-term contracts.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "No catches."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                        children: "Start hiring talents on demand now."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttons),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: _InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Type.WHITE_BLUE_OUTLINE */ .Z.Type.WHITE_BLUE_OUTLINE,
                                size: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.LARGE */ .ZP.Size.LARGE,
                                className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
                                href: {
                                    pathname: "/why",
                                    query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, analyticsData)
                                },
                                children: "Learn How"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: _InteractiveButton_InteractiveButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Type.BLUE */ .Z.Type.BLUE,
                                size: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.LARGE */ .ZP.Size.LARGE,
                                className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
                                href: {
                                    pathname: "/schedule-call",
                                    query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, analyticsData)
                                },
                                children: "Get Started"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().gridItem),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imagesContainer),
                    children: content.images.map(function(_param, index) /*#__PURE__*/ {
                        var url = _param.url, image = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
                            "url"
                        ]);
                        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Long_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                            style: image,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: url,
                                alt: "".concat(index),
                                loading: "lazy"
                            })
                        }, index);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (LongCTA);


/***/ }),

/***/ 53027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22974);
/* harmony import */ var _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90645);
/* harmony import */ var _InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13442);
/* harmony import */ var _InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var InteractiveButton = function(_param) {
    var className = _param.className, to = _param.to, href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "to",
        "href",
        "children"
    ]);
    var Component;
    if (to || href) {
        Component = _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP;
    } else {
        Component = _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_InteractiveButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button), className),
        href: to || href || undefined
    }, props), {
        children: children
    }));
};
InteractiveButton.Type = {
    WHITE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE */ .ZP.Type.WHITE,
    BLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.BLUE */ .ZP.Type.BLUE,
    DARKBLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.DARKBLUE */ .ZP.Type.DARKBLUE,
    WHITE_BLUE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE_BLUE_OUTLINE */ .ZP.Type.WHITE_BLUE_OUTLINE,
    WHITE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.WHITE_OUTLINE */ .ZP.Type.WHITE_OUTLINE,
    BLUE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type.BLUE_OUTLINE */ .ZP.Type.BLUE_OUTLINE
};
InteractiveButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    to: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (InteractiveButton);


/***/ }),

/***/ 10356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Long_gridContainer__v3Rg8","gridItem":"Long_gridItem__rbetr","heading":"Long_heading__oNdMr","description":"Long_description__E6YXU","buttons":"Long_buttons__iLl7e","button":"Long_button__udH0b","imagesContainer":"Long_imagesContainer__HIxrM","image":"Long_image__a_z5F"};

/***/ }),

/***/ 13442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"InteractiveButton_button__x3qDo"};

/***/ })

}]);